import { render, staticRenderFns } from "./crumbs.vue?vue&type=template&id=0ded2c4d&scoped=true&"
var script = {}
import style0 from "./crumbs.vue?vue&type=style&index=0&id=0ded2c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded2c4d",
  null
  
)

export default component.exports